// extracted by mini-css-extract-plugin
export default {"mainLoader":"style_mainLoader__ticVI","innerLoader":"style_innerLoader__uEAN4"};